import React from 'react'
import NavLinkOrA from "./NavLinkOrA"

class MobMenu extends React.Component {
  constructor(props) {
    super(props)
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    this.props.toggleMenu()
  }
  render() {
    return (
      <div className="mm">
        <div className="mm__header">
          <img src="/img/logo/logo.svg" alt="" className="mm__logo__90 "/>
          <div className="mm__close" onClick={() => this.toggleMenu() }></div>
        </div>
        <ul className="mm__list wd">
          <li><NavLinkOrA is404={this.props.is404} onClick={() => this.toggleMenu() } to="/sessions">Сеанси</NavLinkOrA></li>
          <li><NavLinkOrA is404={this.props.is404} onClick={() => this.toggleMenu() } to="/soon">Скоро у прокаті</NavLinkOrA></li>
          <li><NavLinkOrA is404={this.props.is404} onClick={() => this.toggleMenu()} to="/history">Історія</NavLinkOrA></li>
          <li><NavLinkOrA is404={this.props.is404} onClick={() => this.toggleMenu() } to="/contacts">Контакти</NavLinkOrA></li>
        </ul>
        <div className="mm__footer wd">
          <div className="mm__footer__kassa">
            <p className="mm__footer__kassa__label">Каса:</p>
            <a className="mm__footer__kassa__link" href="tel:+380673299830">(067) 329-98-30</a>
          </div>
          <div className="mm__footer__soc">
            <a href="https://instagram.com/zhovten.cinema" className="ig"><img src="/img/header_ig.svg" alt="" /></a>
            <a href="https://facebook.com/zhovten/"><img src="/img/header_fb.svg" alt="" /></a>
          </div>
        </div>
      </div>
    )
  }
}

export default MobMenu


// WEBPACK FOOTER //
// ./src/components/snippets/MobMenu.jsx